import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
} from "async-ops";
import { ALL, ALLSEQUENCE } from "../../../reducers/ea-dashboard-reducer";
import { GET_TOTAL_FILES_SUBMITTED_DATA } from "../services/get-total-files-submitted";
export const SET_TOTAL_FILE_WIDGET_VALUE = "SET_TOTAL_FILE_WIDGET_VALUE";

const initialState = {
    isLoading: false,
    totalFilesSubmitted: [],
    reviewContractors: [],
    sequenceList:[]
};

export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case SET_TOTAL_FILE_WIDGET_VALUE:
            newState = { ...state };
            newState = {
                ...newState,
                reviewContractorId: action.data.reviewContractorId,
                timePeriod: action.data.timePeriod,
                toggleValue: action.data.toggleValue,
                sequenceNo: action.data.sequenceNo
            };
            return newState;
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncOperation(GET_TOTAL_FILES_SUBMITTED_DATA)(action)) {
                return { ...state, totalFilesSubmitted: [],reviewContractors: [],sequenceList:[] };
            }
            if (isAsyncComplete(GET_TOTAL_FILES_SUBMITTED_DATA)(action)) {
                var response = action.response;
                var activeReviewContractor = response?.reviewContractorDto?.length>0 ? response.reviewContractorDto?.filter(x=>x):[];
                activeReviewContractor?.unshift(ALL);
                 var activeSequenceList = response?.sequenceList?.length>0 ? response.sequenceList?.filter(x=>x):[];
                activeSequenceList?.unshift(ALLSEQUENCE);
                return { ...state, totalFilesSubmitted: response.totalFilesSubmitted,reviewContractors: activeReviewContractor ,sequenceList:activeSequenceList};
            }
            return state;
        default:
            return state;
    }
}